import Vue from 'vue'
import VueRouter from 'vue-router'
import routerConfig from './router'
import App from './App'

// Router
Vue.use(VueRouter)

const router = new VueRouter({
  hashbang: true,
  history: true,
  saveScrollPosition: true,
  suppressTransitionError: true
})

routerConfig(router)

router.start(App, '#app')

window.router = router



// WEBPACK FOOTER //
// ./src/main.js